import { render } from "./BookCourse.vue?vue&type=template&id=1feaf74a"
import script from "./BookCourse.vue?vue&type=script&lang=js"
export * from "./BookCourse.vue?vue&type=script&lang=js"

import "./BookCourse.vue?vue&type=style&index=0&id=1feaf74a&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__